
<div mat-dialog-title>iRebal Announcements<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  @if (data) {
    <div class="block">
      @for (message of data.systemMessages; track message) {
        <div class="announcement">
          <div class="block">
            <div class="title">{{message.messageTitle}}</div>
            <div [innerHTML]="message.messageText"></div>
            <div class="right">{{formatDate(message.modifiedDate)}}</div>
            <br class="clear"/>
          </div>
        </div>
      }
    </div>
  }
  <div class="block" style="border-top: 1px solid #ccc; padding-top: 7px;">
    For more information, please contact your FSA or iRebal support team to correct your user configuration at 855-640-2472.
  </div>
</mat-dialog-content>

@if (data) {
  <mat-dialog-actions style="margin-top: 0 !important">
    <button (click)="close()" class="btn-medium-primary">Close</button>
  </mat-dialog-actions>
}
